import React from "react";
import { MessageContainer } from "./Message.styles";

export default function Message() {
  return <MessageContainer>NFC-e já enviada por email</MessageContainer>;
}
